import { events } from "@constants/tracking";
import useAnalytics from "@hooks/useAnalytics";
import type { ProductType } from "@memorang/types";
import { DialogWrapper } from "@memorang/ui";
import { Dialog } from "react-native-paper";
import PurchaseContainer from "./PurchaseContainer";

type Props = {
	visible: boolean;
	handleClose: () => void;
	productType?: ProductType;
	fromHomePage?: boolean;
};

export const PurchaseDialog = ({
	visible,
	handleClose,
	productType,
	fromHomePage,
}: Props) => {
	const { explicitCallTrackCustomEvent } = useAnalytics();

	const getTitle = () => {
		switch (productType) {
			case "STUDY_PACK":
				return "Unlock ProEthica Premium";
			case "PRACTICE_TEST":
				return "Unlock practice tests";
			default:
				return "Upgrade";
		}
	};

	const handleDialogClose = () => {
		handleClose();
		explicitCallTrackCustomEvent({
			eventName: events.paywallClosed,
		});
	};

	return (
		<DialogWrapper visible={visible} handleClose={handleDialogClose}>
			<Dialog.Title style={{ textAlign: "center" }}>{getTitle()}</Dialog.Title>
			<PurchaseContainer
				handleClose={handleDialogClose}
				productType={productType}
				fromHomePage={fromHomePage}
			/>
		</DialogWrapper>
	);
};
